import Vue from 'vue';
import axios from 'axios';
import VueCookies from 'vue-cookies';
import FlashMessage from '@smartweb/vue-flash-message';
import VModal from 'vue-js-modal';
import VueQuagga from 'vue-quaggajs';

import Settings from './utils/settings';
import FeatureFlags from './utils/featureFlags';

import App from './App';
import router from './router';
import store from './store';

import './css/pure-min.css';
import './css/grids-responsive-min.css';
import './css/main.css';
// import './css/font-awesome.min.css';

axios.defaults.baseURL = Settings.server.apiServer;

Vue.prototype.$eventHub = new Vue();

Vue.use(VueCookies);
Vue.use(FlashMessage);
Vue.use(VueQuagga);
Vue.use(VModal, {
  dynamic: true,
  injectModalsContainer: true,
  dynamicDefaults: { clickToClose: false },
});
Vue.use(FeatureFlags);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
